import React from 'react';
import { components, DropdownIndicatorProps, GroupBase, OptionProps } from 'react-select';
import { useTestId } from '../../hooks/useTestId';
import { Icon, IconNames } from '../../Components/Icons/Icon';
import { Size } from '../../common/size';
import { ISelectErrorMessageProps, ISelectStyleProps } from './selectTypes';
import { Text } from '../../Typography/Text/Text';
import { Variant } from '../../common/variant';
import styled from 'styled-components';
import { CheckBox } from '../CheckBox/CheckBox';

export const DropdownSearchIndicator = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: DropdownIndicatorProps<Option, IsMulti, Group>
) => {
  const { generateTestId } = useTestId(props, 'DropdownIndicator');
  return (
    <components.DropdownIndicator {...props}>
      <Icon name={IconNames.Search} size={Size.Medium} {...generateTestId('Icon')} />
    </components.DropdownIndicator>
  );
};

const MenuOptionContainer = styled.div`
  display: inline-flex;
  column-gap: 0.5rem;
  align-items: flex-start;
`;

export const CheckboxOption = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(props: OptionProps<Option, IsMulti, Group>) => {
  const { generateTestId } = useTestId(props, 'ReactSelectOption');

  return (
    <components.Option {...props}>
      <MenuOptionContainer {...generateTestId()}>
        <CheckBox checked={props.isSelected} readOnly label={props.label} />
      </MenuOptionContainer>
    </components.Option>
  );
};

export const SelectErrorMessageContainer: React.FC<Pick<ISelectStyleProps, 'invalid'> & Pick<ISelectErrorMessageProps, 'requiredErrorMessage'>> = ({
  invalid,
  requiredErrorMessage,
  ...rest
}) => {
  const { generateTestId } = useTestId(rest, 'SelectErrorMessage');

  if (!requiredErrorMessage || !invalid) {
    return <></>;
  }

  return (
    <Text size={Size.Small} variant={Variant.Error} {...generateTestId()}>
      {requiredErrorMessage}
    </Text>
  );
};
